var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfigure = function SvgConfigure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.25 3.25h7.5v7.5h-7.5zm10 0h7.5v7.5h-7.5zm-10 10h7.5v7.5h-7.5zm13 0h1.5v3h3v1.5h-3v3h-1.5v-3h-3v-1.5h3zm-1.5-8.5v4.5h4.5v-4.5zm-10 0v4.5h4.5v-4.5zm0 10v4.5h4.5v-4.5z"
  })));
};
export default SvgConfigure;